import styled from 'styled-components';
import { Layout as LayoutDefault } from 'antd';

import { NAVBAR_HEIGHT } from '../constants/ui';

export const Layout = styled(LayoutDefault)`
  background: transparent;
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;
